<!-- eslint-disable max-len -->
<template>
  <aha-modal
    @hide="$emit('hide')"
    :title="$i18nPresenter.t('Take over')"
    class="take-over-modal"
  >
    <p class="mb-2">
      <span v-if="presenting || presentation.TakenOverByUser.accountRole === role.VIEWER" v-html="$i18nPresenter.t('atMomentPrezIsBeingPresented')">
      </span>

      <span v-else v-html="$i18nPresenter.t('atMomentPrezIsBeingEdited')">
      </span>
    </p>
    <div class="flex items-center p-2 mb-3 bg-secondary-10">
      <aha-avatar
        class="mr-2 text-lg"
        :name="presentation.TakenOverByUser.firstName"
        :image="presentation.TakenOverByUser.avatar"
        :id="presentation.TakenOverByUser.id"
        :width="36"
        :height="36"
      />
      <div class="flex flex-col">
        <span class="font-bold">
          <strong>{{ presentation.TakenOverByUser.firstName }}</strong>
        </span>
        <p>{{ presentation.TakenOverByUser.email }}</p>
      </div>
    </div>
    <p>
      {{ $i18nPresenter.t('Once you take over, they will become a viewer and only you will be able to edit this presentation.') }}
    </p>
    <template #action>
      <aha-antd-button
        v-aha-emit-action
        name="cancel_take_over_button"
        variant="text"
        class="mr-4 font-semibold"
        @click="$emit('hide')"
      >
        {{ $i18nPresenter.t('Cancel') }}
      </aha-antd-button>
      <aha-antd-button
        v-aha-emit-action
        name="take_over_button"
        variant="danger"
        @click="$emit('takeOver')"
        is-loading-inline
        :submitting="submitting"
      >
        {{ $i18nPresenter.t('Take over') }}
      </aha-antd-button>
    </template>
  </aha-modal>
</template>

<script>
import { mapState } from 'vuex'
import constants from '@/constant'

export default {
  props: {
    presenting: {
      type: Boolean,
      default: false,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      role: constants.role,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
  },
}
</script>

<style lang="scss" scoped>

</style>
